import React from "react";

import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { ConstructDestinationUrl } from "../construct-destination-url";

export const StackAdapt = () => (
  <div className="flex flex-col gap-3">
    <p className="mb-0">
      You will need to add UTM parameters to all new and existing URLs.
    </p>
    <ConstructDestinationUrl platform={NorthbeamUtmPlatform.STACK_ADAPT} />
  </div>
);
